import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';
import { ProductsProps } from 'utils/types';

export const fileKey = ['fileProduct'];

const useCroptimizerProduct = () => useQuery({
  queryKey: [fileKey, 'croptimizer'],
  queryFn: () => agent.getClient()('file-data/croptimizer?tag=products').then((response) => {
    const result: ProductsProps[] = [];
    response?.data?.data?.forEach((element: any) => {
      result.push({
        ['Country']: element?.['0'],
        ['Products']: element?.['1'],
        ['Price']: element?.['2'],
        ['NV']: element?.['3'],
        ['CAP']: element?.['4'],
      });
    });

    return result as ProductsProps[];
  }),
});

export default useCroptimizerProduct;
